module.exports = __webpack_public_path__ + "img/logo-ct.6f598d1f.png";